import { EnquiryModel } from "./enquiry.model";

export class ContactModel extends EnquiryModel {
    surname: string;
}
